import { motion } from "framer-motion";

/**
 * Word-by-word reveal — masks each word with a translateY animation.
 * Use for hero / large headings.
 */
export default function WordReveal({ text, className = "", delay = 0, stagger = 0.08, italicWords = [] }) {
  const words = text.split(" ");
  return (
    <span className={`inline-block ${className}`} aria-label={text}>
      {words.map((w, i) => {
        const isItalic = italicWords.includes(w.replace(/[.,!?]/g, ""));
        return (
          <span key={i} className="inline-block overflow-hidden align-bottom mr-[0.22em] pb-[0.12em] -mb-[0.12em]" aria-hidden>
            <motion.span
              className={`inline-block ${isItalic ? "italic font-light opacity-95" : ""}`}
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{
                duration: 0.9,
                ease: [0.16, 1, 0.3, 1],
                delay: delay + i * stagger,
              }}
            >
              {w}
            </motion.span>
          </span>
        );
      })}
    </span>
  );
}
